import { render, staticRenderFns } from "./HorizontalTripCard.vue?vue&type=template&id=517fea88&scoped=true&lang=pug&"
import script from "./HorizontalTripCard.vue?vue&type=script&lang=js&"
export * from "./HorizontalTripCard.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTripCard.vue?vue&type=style&index=0&id=517fea88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517fea88",
  null
  
)

export default component.exports